var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachineUnselected = function SvgMachineUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.556,
    d: "M1.037 16.924h21.677a.26.26 0 0 1 .26.26v.933a.26.26 0 0 1-.26.259h-1.536a1.27 1.27 0 0 0-1.239-.985H3.76c-.603 0-1.108.42-1.238.985H1.037a.26.26 0 0 1-.26-.26v-.933a.26.26 0 0 1 .26-.26ZM9.334 1.47h13.484a.26.26 0 0 1 .259.26v12.342a.26.26 0 0 1-.26.259H9.335a.26.26 0 0 1-.259-.26V1.73a.26.26 0 0 1 .26-.259Zm-8.297 0H6.43a.26.26 0 0 1 .26.26v12.342a.26.26 0 0 1-.26.259H1.037a.26.26 0 0 1-.26-.26V1.73a.26.26 0 0 1 .26-.259Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.037,
    d: "M11.72 8.782v-4.46h8.712v4.46z"
  })));
};
export default SvgMachineUnselected;